import React from 'react'

import Link from '../Link'

import {
  mainBlackHeaderContainer,
  mainBlackHeaderCta,
} from './index.module.css'

const MainBlackHeader = ({ title, ctaUrl, linkh1 }) => {
  return linkh1 ? (
    <div className={mainBlackHeaderContainer}>
      <Link className={mainBlackHeaderCta} to={ctaUrl}>
        <h1>{title && title}</h1>
      </Link>
    </div>
  ) : (
    <div className={mainBlackHeaderContainer}>
      {ctaUrl ? (
        <Link className={mainBlackHeaderCta} to={ctaUrl}>
          <h2>{title && title}</h2>
        </Link>
      ) : (
        <h1>{title && title}</h1>
      )}
    </div>
  )
}

export default MainBlackHeader
